import {
  DEFAULT_DOMAIN_OPTIONS,
  type DomainKey,
  type DomainOptionsDto,
} from "./defaults.ts";

export function mergeDomainOptions(
  api?: { options?: DomainOptionsDto | null } | null,
): DomainOptionsDto {
  if (!api?.options) return DEFAULT_DOMAIN_OPTIONS;
  return {
    sales_pipeline: {
      ...DEFAULT_DOMAIN_OPTIONS.sales_pipeline,
      ...api.options.sales_pipeline,
    },
    accounts: {
      ...DEFAULT_DOMAIN_OPTIONS.accounts,
      ...api.options.accounts,
    },
    users: {
      ...DEFAULT_DOMAIN_OPTIONS.users,
      ...api.options.users,
    },
    design_requests: {
      ...DEFAULT_DOMAIN_OPTIONS.design_requests,
      ...api.options.design_requests,
    },
    licensing: {
      ...DEFAULT_DOMAIN_OPTIONS.licensing,
      ...api.options.licensing,
    },
    orders: {
      ...DEFAULT_DOMAIN_OPTIONS.orders,
      ...api.options.orders,
    },
    payments: {
      ...DEFAULT_DOMAIN_OPTIONS.payments,
      ...api.options.payments,
    },
    fulfillment: {
      ...DEFAULT_DOMAIN_OPTIONS.fulfillment,
      ...api.options.fulfillment,
    },
    inventory: {
      ...DEFAULT_DOMAIN_OPTIONS.inventory,
      ...api.options.inventory,
    },
  };
}

export function getDomainOptions(
  options: DomainOptionsDto,
  domain: DomainKey,
  set: string,
) {
  return options[domain]?.[set] ?? [];
}

export function getOptionLabel(
  options: DomainOptionsDto,
  domain: DomainKey,
  set: string,
  value: string | null | undefined,
): string {
  if (!value) return "";
  return (
    getDomainOptions(options, domain, set).find((row) => row.value === value)
      ?.label ?? value
  );
}

export function labelMapFor<const T extends string>(
  options: DomainOptionsDto,
  domain: DomainKey,
  set: string,
): Record<T, string> {
  const rows = getDomainOptions(options, domain, set);
  return Object.fromEntries(rows.map((row) => [row.value, row.label])) as Record<
    T,
    string
  >;
}
